import getComplianceAndPersonalAddressStatus from 'features/Onboarding/modules/ComplianceAndPersonalAddress/libs/getComplianceAndPersonalAddressStatus';
import { ApplicantType } from 'features/Onboarding/types';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import { GetVerificationStep } from './types';

const getComplianceAndPersonalAddressStep: GetVerificationStep = ({
  applicantType,
  verificationData,
}) => {
  const status = getComplianceAndPersonalAddressStatus({
    applicantType,
    userProfile: verificationData.viewer.profile,
  });

  return {
    errors: [],
    id: State.COMPLIANCE_AND_PERSONAL_ADDRESS,
    metadata: {
      event: model.events.GO_COMPLIANCE_AND_PERSONAL_ADDRESS(),
      iconName: 'profile',
      /**
       * The compliance and personal address modules are shown earlier in most flows.
       * In the beneficiary and invited account holder flows however, it’s shown in the verification home.
       */
      isHidden:
        applicantType !== ApplicantType.InvitedBeneficiary &&
        applicantType !== ApplicantType.InvitedAccountHolder,
      label: locales.complianceAndPersonalAddress,
    },
    status,
  };
};

export default getComplianceAndPersonalAddressStep;
